import React from 'react';

import { SelectInput} from '@sogei/react-web-components-catalog'
import { AppButton } from '../commons/button';
import { observer, inject } from "mobx-react";
import i18next from 'i18next';



@inject("rootStore")
@observer
class DownloadDocumento extends React.Component {

  constructor(props) {
    super(props);
    this.item = this.props.item;
    this.element = this.props.element;
    this.ricevuteStore = props.rootStore.ricevuteStore;
    
  
  }

  componentDidMount() {
   
    
  }

 
   

  render() {

    const documentIcon = (border, icon, iconStyle, spanSrOnly, onClick,titolo) => {
        let customClass = 'btn btn-light border ' + border;
        let iconCenter = icon + ' ' + iconStyle;
        return <AppButton color="none" spanSrOnly={i18next.t(spanSrOnly)} customClass={customClass} iconCenter={iconCenter} type="button"  onClick={onClick} titleKey='' extraProps={{title:i18next.t(titolo)}}/>
      }

    
    const downloadDocumento = (item,element )=> {
      if( (!item.condizione?true:item[element.nomeKeyServizio]==item.condizione) && item[element.file]){
          let downloadParam
          let colore = "info"
          if( item[element.file] instanceof Object ){
              downloadParam = {fileMetaData: item[element.file]};
              if(element.idAtmos){
              
                downloadParam.idAtmos = downloadParam.fileMetaData.chiaveDocumento;
                }
              
            colore = item[element.file]["colore"];
            
          }
          else{
            downloadParam = {idFile: item[element.file]};
            
          }
        
        
  
      return documentIcon(
        /*element.warning?
          item[element.nomeKeyServizio] == element.warning ? 'border-warning' : 'border-danger'
          :
          'border-info',
          element.icon,
          element.warning?
          item[element.nomeKeyServizio] == element.warning ? 'icon-warning' : 'icon-danger'
          :
          'icon-info',
          element.spanSrOnly,
          () => {this.ricevuteStore.downloadFile(downloadParam)},
          ''
          */
          'border-'+colore,
          element.icon,
          'icon-'+colore,
          element.spanSrOnly,
          () => {this.ricevuteStore.downloadFile(downloadParam)},
          ''

          )
        }
        else return " - "
  
  
  
  
    }

    
  
  
  
  
  
    return (
        downloadDocumento(this.item,this.element)

    );
      
    }
    

    }
    
   
  






//export default SceltaTipoInvio;

export {DownloadDocumento}; 